<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <el-form :model="queryParams" ref="queryParams" size="small" v-show="showSearch" label-width="120px">
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="6">
              <el-form-item label="仪器编号" prop="eqptNum">
                <el-input v-model="queryParams.eqptNum" placeholder="请输入仪器编号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="仪器名称" prop="eqptName">
                <el-input v-model="queryParams.eqptName" placeholder="请输入仪器名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="型号规格" prop="eqptSpecification">
                <el-input v-model="queryParams.eqptSpecification" placeholder="请输入规格" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="现状" prop="eqptSituation">
                <el-select v-model="queryParams.eqptSituation" placeholder="请选择现状" clearable style="width: 100%;">
                  <el-option label="完好" value="完好" />
                  <el-option label="准用" value="准用" />
                  <el-option label="降级使用" value="降级使用" />
                  <el-option label="报修" value="报修" />
                  <el-option label="待报废" value="待报废" />
                  <el-option label="报废" value="报废" />
                  <el-option label="外借" value="外借" />
                  <el-option label="停用" value="停用" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="eqptManufacturer">
                <el-input v-model="queryParams.eqptManufacturer" placeholder="请输入生产厂家" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="使用科室" prop="eqptDepartment">
                <el-input v-model="queryParams.eqptDepartment" placeholder="请输入使用科室" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出厂编号" prop="eqptFactoryNumber">
                <el-input v-model="queryParams.eqptFactoryNumber" placeholder="请输入出厂编号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="检定/校准日期" prop="eqptVerificationDateRange">
                <el-date-picker v-model="queryParams.eqptVerificationDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                style="width: 100%;" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 移除了过期时间搜索框 -->
          <div style="text-align: center;margin-bottom: 10px;">
            <!-- <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            <el-button type="success" icon="el-icon-plus" size="mini" @click="handleAdd('Add')">新增</el-button>
            <el-button type="warning" icon="el-icon-download" size="mini" v-hasPermi="['invoicing:export']" v-if="optPerm.export" @click="exportToExcel">导出</el-button>
            <el-upload ref="upload" accept=".xls,.xlsx" action="#" :limit="1" :auto-upload="false" :on-change="fileHandleChange" :on-remove="removeFile" :show-file-list="false"
                       style="display: inline-block;margin-left: 10px;">
              <div>
                <el-button size="mini" type="warning" icon="el-icon-upload2">批量导入</el-button>
              </div>
            </el-upload> -->
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleQuery" @handleAdd="handleAdd('Add')" @exportToExcel="exportToExcel" @handleUpload="handleUpload"
                                     @downloadTemplate="downloadTemplate" @EQconfiguration="EQconfiguration" />
          </div>
          <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }">
            <el-table-column label="序号" align="left" prop="idx" width="50" show-overflow-tooltip></el-table-column>
            <el-table-column label="仪器编号" align="left" prop="eqptNum" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="仪器名称" align="left" prop="eqptName" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="型号规格" align="left" prop="eqptSpecification" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="生产厂家" align="left" prop="eqptManufacturer" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="出厂编号" align="left" prop="eqptFactoryNumber" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="测量范围" align="left" prop="eqptMeasuringRange" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column label="精度等级" align="left" prop="eqptPrecision" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column label="购置日期" align="left" prop="eqptPurchaseDate" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ formatDate(scope.row.eqptPurchaseDate) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单价(元)" align="left" prop="unitPrice" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="量值溯源方式" align="left" prop="sourceType" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="检定/校准周期" align="left" prop="eqptVerificationCycle" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="检定/校准单位" align="left" prop="eqptVerificationUnit" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column label="检定/校准证书编号" align="left" prop="certificateNo" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="检定/校准日期" align="left" prop="eqptVerificationDate" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ formatDate(scope.row.eqptVerificationDate) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期至" align="left" prop="eqptVerificationValidity" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ formatDate(scope.row.eqptVerificationValidity) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="现状" align="left" prop="eqptSituation" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="使用科室" align="left" prop="eqptDepartment" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="保管人" align="left" prop="eqptCustodian" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="left" prop="operation" min-width="420" show-overflow-tooltip fixed="right">
              <template slot-scope="scope">
                <!-- <el-button type="text" size="small" @click="handleUpdate(scope.row)">仪器详情</el-button>
                <el-button type="text" size="small" @click="handleCheck(scope.row)">检定详情</el-button>
                <el-button type="text" size="small" @click="handleCalibrationAdd(scope.row)">添加检定信息</el-button>
                <el-button v-if="scope.row.files && scope.row.files.length > 0 && scope.row.files[0].loadFileUrl" type="text" size="small"
                           @click="upload(scope.row.files[0].loadFileUrl)">下载文件</el-button> -->
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleUpdate="handleUpdate(scope.row)" @handleCheck="handleCheck(scope.row)" @handleCalibrationAdd="handleCalibrationAdd(scope.row)"
                                     @upload="upload(scope.row.files[0].loadFileUrl)" />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="getList" @current-change="getList" :current-page.sync="queryParams.currPage" :page-size="queryParams.pageSize" layout="total, prev, pager, next"
                         :total="total" />
        </el-form>
      </el-col>
    </el-row>
    <el-dialog title="检定详情" :visible.sync="checkVisible" width="80%" append-to-body>
      <el-table :data="checkData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }">
        <el-table-column label="仪器编号" align="left" prop="eqptNum" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="仪器名称" align="left" prop="eqptName" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="校验类型" align="left" prop="eqptType" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="校准方式" align="left" prop="eqptWay" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="校准/检定单位" align="left" prop="eqptOrg" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="证书编号" align="left" prop="certificateNo" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="检定/校准结论" align="left" prop="eqptConclusion" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="检定/校准日期" align="left" prop="eqptDate" min-width="160" show-overflow-tooltip sortable>
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.eqptDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期至" align="left" prop="eqptValidity" min-width="160" show-overflow-tooltip sortable>
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.eqptValidity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="相关文件" align="left" min-width="260">
          <template slot-scope="scope">
            <div v-if="scope.row.files && scope.row.files.length > 0" class="file-list">
              <span v-for="(file, index) in scope.row.files" :key="index">
                <el-link type="primary" @click="downloadFile(file)" :underline="false">
                  <i class="el-icon-document"></i> {{file.fileName}}
                </el-link>
                <span v-if="index < scope.row.files.length - 1" class="file-separator">、</span>
              </span>
            </div>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- PDF预览对话框 -->
    <el-dialog title="文件预览" :visible.sync="isPdfViewVisible" width="80%" append-to-body>
      <PdfImgViewer ref="pdfImgViewer" :fileName="viewFileName"></PdfImgViewer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isPdfViewVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <AddAndEdit ref="addAndEdit" @refresh="refresh" @test="handleTest" />
    <CalibrationAddAndEdit ref="calibrationAddAndEdit" @refresh="Calibratrefresh" />
    <ToolboxConfigDialog ref="toolboxConfigDialog" @refresh="getList" />
  </div>
</template>

<script>
import { queryEqptList, exportEqptExcel, downloadEqptTemplate, importEqptData, queryEqptVerificationList, queryEqptVerificationByEqptNum } from '@/api/contract/contract'
import AddAndEdit from './AddAndEdit.vue'
import CalibrationAddAndEdit from '../calibration/calibrationAddAndEdit.vue'
import PdfImgViewer from "@/components/pdfview/PdfImgViewer.vue"
import ToolboxConfigDialog from './ToolboxConfigDialog.vue'
export default {
  name: 'Instrument-base-list',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    AddAndEdit,
    CalibrationAddAndEdit,
    PdfImgViewer,
    ToolboxConfigDialog
  },
  data () {
    return {
      optPerm: {},
      // 显示搜索条件
      showSearch: true,
      tableData: [],
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 10,
        eqptVerificationDateRange: [],
        eqptSituation: '完好'
      },
      fileList: [], // 文件列表
      checkVisible: false, // 检定详情弹窗
      checkData: [], // 检定详情数据
      // 测试数据
      testData: [],
      // 文件预览相关
      isPdfViewVisible: false,
      viewFileName: ''
    };
  },
  created () {
    this.getList()
  },
  methods: {
    // 格式化日期，只保留日期部分
    formatDate (dateTimeString) {
      if (!dateTimeString) return '';
      // 如果包含时间，则只返回日期部分
      if (dateTimeString.includes(' ')) {
        return dateTimeString.split(' ')[0];
      }
      return dateTimeString;
    },
    // 搜索
    handleQuery () {
      this.getList()
    },
    // 查询列表
    getList () {
      this.loading = true
      queryEqptList(this.queryParams).then(res => {
        console.log(res)
        if (res.retCode === 'ok') {
          this.tableData = res.additionalData.records
          this.total = res.additionalData.total
          this.queryParams.currPage = res.additionalData.current
          this.queryParams.pageSize = res.additionalData.size
          this.loading = false
        } else {
          this.$message.error(res.retMsg)
          this.loading = false
        }
      })
    },

    // 新增
    handleAdd () {
      this.$refs.addAndEdit.handleAdd()
    },
    // 添加检定信息
    handleCalibrationAdd (row) {
      this.$refs.calibrationAddAndEdit.openDialog("Add", row);
    },
    // 修改按钮
    handleEdit (row) {
      this.$refs.calibrationAddAndEdit.openDialog('Edit', row);
    },
    // 修改
    handleUpdate (row) {
      this.$refs.addAndEdit.handleUpdate(row)
    },
    handleUpload () {
      // 弹出对话框询问用户
      this.$confirm('请选择操作', '批量导入', {
        distinguishCancelAndClose: true,
        confirmButtonText: '直接上传文件',
        cancelButtonText: '下载导入模板',
        type: 'info'
      }).then(() => {
        // 用户选择直接上传
        this.selectFileToUpload()
      }).catch(action => {
        if (action === 'cancel') {
          // 用户选择下载模板
          this.downloadTemplate()
        }
        // 如果是关闭对话框，不做任何操作
      })
    },

    // 选择文件并上传
    selectFileToUpload () {
      // 创建文件输入元素
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.xls,.xlsx'
      input.onchange = (e) => {
        const file = e.target.files[0]
        if (!file) return

        // 验证文件类型
        const fileName = file.name
        const fileExt = fileName.substring(fileName.lastIndexOf('.'))
        if (!['.xls', '.xlsx'].includes(fileExt.toLowerCase())) {
          this.$message.error('只支持上传.xls或.xlsx格式的文件')
          return
        }

        // 创建FormData
        const formData = new FormData()
        formData.append('file', file)

        // 显示加载提示
        const loading = this.$loading({
          lock: true,
          text: '正在导入数据...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 调用导入接口
        importEqptData(formData).then(res => {
          loading.close()
          if (res.retCode === 'ok') {
            this.$message.success('导入成功')
            // 刷新列表
            this.getList()
          } else {
            // 显示详细的错误信息（支持HTML格式）
            this.$alert(res.retMsg || '导入失败', '导入结果', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            })
          }
        }).catch(error => {
          loading.close()
          console.error('导入失败:', error)
          this.$message.error('导入失败：' + (error.message || '未知错误'))
        })
      }
      input.click()
    },

    // 下载导入模板
    downloadTemplate () {
      this.$message.success('正在下载模板...')

      downloadEqptTemplate().then(response => {
        // 创建下载链接
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)

        // 创建下载链接元素
        const link = document.createElement('a')
        link.href = url
        link.download = '仪器信息导入模板.xlsx'

        // 触发下载
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()

        // 清理
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$message.success('模板下载成功，请填写后再次点击"批量导入"上传文件')
      }).catch(error => {
        console.error('模板下载失败:', error)
        this.$message.error('模板下载失败：' + (error.message || '未知错误'))
      })
    },
    // 仪器工具箱配置
    EQconfiguration () {
      this.$refs.toolboxConfigDialog.openDialog()
    },
    // 测试事件处理方法
    handleTest (value) {
      console.log('接收到测试事件:', value);
    },
    refresh (newData) {
      console.log('refresh方法被调用 - 正在刷新仪器列表');
      if (newData) {
        // 检查是否已存在该仪器编号
        const existingIndex = this.testData.findIndex(item => item.eqptNum === newData.eqptNum);
        if (existingIndex >= 0) {
          // 更新现有数据
          this.testData.splice(existingIndex, 1, newData);
        } else {
          // 添加新数据
          newData.idx = this.testData.length + 1;
          this.testData.push(newData);
        }
      }
      // 强制延时执行，确保DOM更新完成
      setTimeout(() => {
        this.getList();
        console.log('仪器列表刷新完成');
      }, 100);
    },
    Calibratrefresh () {
      console.log('Calibratrefresh method called');
      this.getList();
    },
    // 检定详情
    handleCheck (row) {
      this.checkVisible = true
      // 模拟检定详情数据
      queryEqptVerificationByEqptNum({
        eqptNum: row.eqptNum,
        eqptNumSearchType: '=',
        currPage: 1,
        pageSize: 50
      }).then(res => {
        if (res.retCode === 'ok') {
          this.checkData = res.additionalData.records
        }
      })
    },

    // 文件状态改变时的钩子
    fileHandleChange (file, fileList) {
      this.$message.success('导入成功')
    },
    // 文件删除的钩子
    removeFile (file, fileList) {
      this.fileList = fileList
    },
    // 下载文件 - 处理单个文件对象或文件URL
    downloadFile (file) {
      console.log('预览文件:', file);

      // 检查文件对象是否存在且包含filePath
      if (!file || !file.filePath) {
        this.$message.warning('文件路径无效');
        return;
      }

      // 设置预览文件名并打开预览对话框
      this.viewFileName = file.filePath;
      this.isPdfViewVisible = true;

      // 确保组件初始化
      this.$nextTick(() => {
        if (this.$refs.pdfImgViewer) {
          this.$refs.pdfImgViewer.init();
        }
      });
    },
    // 下载按钮点击事件 - 作为downloadFile的快捷方式
    upload (fileUrl) {
      // 直接在新窗口打开文件链接
      window.open(fileUrl, '_blank');
    },
    // 导出按钮
    exportToExcel () {
      this.$message.success('正在导出仪器数据...')

      // 调用导出接口
      exportEqptExcel(this.queryParams).then(response => {
        // response 为 axios 原始响应：{ data: Blob, headers: {...} }
        const blob = (response && response.data instanceof Blob)
          ? response.data
          : (response instanceof Blob ? response : new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }))

        // 后端可能返回 JSON 错误信息，但被当成 blob 返回
        if (blob && blob.type && blob.type.includes('application/json')) {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const errorData = JSON.parse(reader.result)
              this.$message.error(errorData.retMsg || errorData.message || '导出失败')
            } catch (e) {
              this.$message.error('导出失败')
            }
          }
          reader.readAsText(blob)
          return
        }

        // 从响应头解析文件名（Content-Disposition），避免写死
        const disposition = response && response.headers
          ? (response.headers['content-disposition'] || response.headers['Content-Disposition'])
          : ''
        const fileName = this.getFileNameFromDisposition(disposition) || '仪器信息.xlsx'

        const url = window.URL.createObjectURL(blob)

        // 创建下载链接元素
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName; // 文件名（优先后端返回）

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    },
    // 从 Content-Disposition 响应头中解析文件名
    getFileNameFromDisposition (disposition) {
      if (!disposition) return ''

      // RFC5987: filename*=UTF-8''xxx
      const utf8Match = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
      if (utf8Match && utf8Match[1]) {
        try {
          return decodeURIComponent(utf8Match[1].replace(/(^\"|\"$)/g, '').trim())
        } catch (e) {
          return utf8Match[1].replace(/(^\"|\"$)/g, '').trim()
        }
      }

      // 普通：filename="xxx"
      const normalMatch = disposition.match(/filename\s*=\s*([^;]+)/i)
      if (normalMatch && normalMatch[1]) {
        let name = normalMatch[1].trim()
        name = name.replace(/(^\"|\"$)/g, '')
        // 有些后端会把中文做 URL 编码
        try {
          return decodeURIComponent(name)
        } catch (e) {
          return name
        }
      }

      return ''
    }
  }
}
</script>
<style scoped>
.file-item {
  padding: 3px 0;
  text-align: left;
}
.file-item .el-link {
  display: inline-flex;
  align-items: center;
}
.file-item .el-icon-document {
  margin-right: 5px;
}
.file-list {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
}
.file-separator {
  margin: 0 2px;
}
</style>